export const validateUrl = (url: string): boolean => {
	try {
		const trimmedUrl = url.trim();

		if (!trimmedUrl) {
			return false;
		}

		// Reject strings that are only numbers
		if (/^\d+$/.test(trimmedUrl)) {
			return false;
		}

		// Check if it already has http:// or https:// protocol
		const hasProtocol = /^https?:\/\//i.test(trimmedUrl);

		// If it doesn't have protocol, add https:// temporarily for validation
		const urlWithProtocol = hasProtocol ? trimmedUrl : `https://${trimmedUrl}`;

		const urlObject = new URL(urlWithProtocol);
		const hostname = urlObject.hostname;

		// Reject empty or malformed hostnames
		if (!hostname) {
			return false;
		}

		// Check if hostname has at least one dot and is not only numbers
		const hasValidDomain =
			hostname.includes('.') && hostname.length > 3 && !/^\d+$/.test(hostname);

		return hasValidDomain;
	} catch {
		return false;
	}
};
